(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.querySelectorAll('[data-ceme-announcement]').forEach((bar) => {
    const slides = Array.from(bar.querySelectorAll('[data-announcement-slide]'));
    const previous = bar.querySelector('[data-announcement-prev]');
    const next = bar.querySelector('[data-announcement-next]');
    if (slides.length < 2) return;

    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    const setActive = (nextIndex, direction = 'next') => {
      bar.dataset.direction = direction;
      slides[index].classList.remove('is-active');
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    };

    previous.addEventListener('click', () => setActive(index - 1, 'previous'));
    next.addEventListener('click', () => setActive(index + 1, 'next'));

    if (bar.dataset.autoRotate === 'true') {
      const interval = Number(bar.dataset.interval || 5000);
      window.setInterval(() => setActive(index + 1, 'next'), interval);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ceme-card-images"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('[data-track]');if(!track)return;let busy=false;const gap=()=>parseFloat(getComputedStyle(track).gap)||0;const cards=()=>Array.from(track.querySelectorAll('[data-slide]'));const normalize=()=>{const list=cards();list.forEach((card,index)=>card.classList.toggle('is-primary',index===0));track.scrollLeft=0};const next=()=>{if(busy||cards().length<2)return;busy=true;const list=cards(),first=list[0],second=list[1];first.classList.remove('is-primary');second.classList.add('is-primary');requestAnimationFrame(()=>track.scrollTo({left:second.offsetLeft,behavior:'smooth'}));setTimeout(()=>{track.append(first);normalize();busy=false},620)};const previous=()=>{if(busy||cards().length<2)return;busy=true;const list=cards(),first=list[0],last=list[list.length-1];track.prepend(last);track.scrollLeft=last.getBoundingClientRect().width+gap();requestAnimationFrame(()=>{first.classList.remove('is-primary');last.classList.add('is-primary');track.scrollTo({left:0,behavior:'smooth'})});setTimeout(()=>{normalize();busy=false},620)};root.querySelector('[data-previous]')?.addEventListener('click',previous);root.querySelector('[data-next]')?.addEventListener('click',next);let timer;const stop=()=>{clearInterval(timer);timer=undefined};const start=()=>{if(root.dataset.mode==='auto'&&!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(next,Number(root.dataset.interval)||5000)};normalize();start();root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',()=>{if(!timer)start()});root.addEventListener('shopify:block:select',event=>{stop();const selected=event.target;if(!selected.matches?.('[data-slide]'))return;while(track.firstElementChild!==selected)track.append(track.firstElementChild);normalize()})};document.querySelectorAll('[data-ceme-carousel]').forEach(init);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ceme-carousel]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ceme-chat-box"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ceme-chat]').forEach((chat) => {
    const launcher = chat.querySelector('.ceme-chat__launcher');
    const panel = chat.querySelector('.ceme-chat__panel');
    const close = chat.querySelector('[data-chat-close]');
    const form = chat.querySelector('[data-chat-form]');
    const input = form?.querySelector('input');
    const messages = chat.querySelector('[data-chat-messages]');
    const normalize = (value) => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const setOpen = (open) => { panel.hidden = !open; launcher.setAttribute('aria-expanded', String(open)); if (open) input?.focus(); };
    launcher?.addEventListener('click', () => setOpen(panel.hidden));
    close?.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !panel.hidden) setOpen(false); });
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const question = input.value.trim();
      if (!question) return;
      const user = document.createElement('div');
      user.className = 'ceme-chat__message ceme-chat__message--question';
      user.textContent = question;
      messages.append(user);
      const normalizedQuestion = normalize(question);
      const match = Array.from(chat.querySelectorAll('template[data-chat-answer]')).find((item) => item.dataset.keywords.split(',').map(normalize).filter(Boolean).some((keyword) => normalizedQuestion.includes(keyword)));
      const answer = document.createElement('div');
      answer.className = 'ceme-chat__message ceme-chat__message--answer';
      if (match) {
        answer.append(match.content.cloneNode(true));
      } else {
        const fallback = chat.querySelector('[data-chat-no-match]');
        answer.innerHTML = fallback?.innerHTML || '';
      }
      messages.append(answer);
      input.value = '';
      messages.scrollTop = messages.scrollHeight;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ceme-testimonials"] && !Shopify.designMode) return;
  try {
    
 window.cemeTestimonialsRevision='20260807';
 (()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('[data-track]');if(!track)return;let busy=false;const slides=()=>Array.from(track.querySelectorAll('[data-slide]'));const step=()=>{const slide=track.querySelector('[data-slide]');return slide?slide.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0):track.clientWidth};const motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';const afterPaint=()=>new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));const jump=async action=>{track.classList.add('is-jumping');action();void track.offsetWidth;await afterPaint();track.classList.remove('is-jumping')};const waitForScrollEnd=target=>new Promise(resolve=>{let idle;let maximum;let finished=false;const finish=()=>{if(finished)return;finished=true;clearTimeout(idle);clearTimeout(maximum);track.removeEventListener('scroll',check);resolve()};const check=()=>{clearTimeout(idle);idle=setTimeout(()=>{if(Math.abs(track.scrollLeft-target)<2)finish()},90)};track.addEventListener('scroll',check,{passive:true});maximum=setTimeout(finish,1000);check()});const next=async()=>{if(busy||slides().length<2)return;busy=true;const first=track.firstElementChild;const target=step();track.scrollTo({left:target,behavior:motion()});await waitForScrollEnd(target);await jump(()=>{track.append(first);track.scrollLeft=0});busy=false};const previous=async()=>{if(busy||slides().length<2)return;busy=true;const last=track.lastElementChild;await jump(()=>{track.prepend(last);track.scrollLeft=step()});track.scrollTo({left:0,behavior:motion()});await waitForScrollEnd(0);busy=false};root.querySelector('[data-previous]')?.addEventListener('click',previous);root.querySelector('[data-next]')?.addEventListener('click',next);let timer;const stop=()=>{clearInterval(timer);timer=undefined};const start=()=>{if(root.dataset.mode==='auto'&&!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(next,Number(root.dataset.interval)||5000)};track.scrollLeft=0;start();root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',()=>{if(!timer)start()});root.addEventListener('shopify:block:select',event=>{stop();const selected=event.target;if(!selected.matches?.('[data-slide]'))return;while(track.firstElementChild!==selected)track.append(track.firstElementChild);track.scrollLeft=0})};document.querySelectorAll('[data-testimonial-carousel]').forEach(init);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-testimonial-carousel]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const media = window.matchMedia('(max-width: 749px)');
    const sync = (root) => {
      root.querySelectorAll('.ceme-footer__accordion').forEach((accordion) => {
        if (media.matches) {
          accordion.removeAttribute('open');
        } else {
          accordion.setAttribute('open', '');
        }
      });
    };
    const syncAll = () => document.querySelectorAll('.ceme-footer').forEach(sync);
    syncAll();
    media.addEventListener('change', syncAll);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.ceme-footer').forEach(sync);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.ceme-header').forEach((header) => {
    if (header.classList.contains('ceme-header--home-video-overlay')) {
      const updateHomeHeader = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      updateHomeHeader();
      window.addEventListener('scroll', updateHomeHeader, { passive: true });
    }
    if (header.dataset.dropdownTrigger === 'click') {
      header.querySelectorAll('.ceme-nav__item').forEach((item) => {
        const link = item.querySelector('.ceme-nav__link');
        const panel = item.querySelector('.ceme-mega, .ceme-dropdown');
        if (!link || !panel) return;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          header.querySelectorAll('.ceme-nav__item.is-open').forEach((openItem) => {
            if (openItem !== item) {
              openItem.classList.remove('is-open');
              openItem.querySelector('.ceme-nav__link')?.setAttribute('aria-expanded', 'false');
            }
          });
          const willOpen = !item.classList.contains('is-open');
          item.classList.toggle('is-open', willOpen);
          link.setAttribute('aria-expanded', String(willOpen));
        });
      });
      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) {
          header.querySelectorAll('.ceme-nav__item.is-open').forEach((item) => {
            item.classList.remove('is-open');
            item.querySelector('.ceme-nav__link')?.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }
    const button = header.querySelector('.ceme-header__menu');
    const menu = header.querySelector('.ceme-mobile-menu');
    if (!button || !menu) return;
    const closeButton = menu.querySelector('.ceme-mobile-menu__close');
    const setMenuState = (isOpen) => {
      button.setAttribute('aria-expanded', String(isOpen));
      menu.hidden = !isOpen;
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      if (isOpen) {
        closeButton?.focus();
      } else {
        menu.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
      }
    };
    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      setMenuState(!isOpen);
    });
    closeButton?.addEventListener('click', () => {
      setMenuState(false);
      button.focus();
    });
    menu.addEventListener('click', (event) => {
      if (event.target === menu) {
        setMenuState(false);
        button.focus();
      }
    });
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        setMenuState(false);
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) {
        setMenuState(false);
        button.focus();
      }
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 900 && !menu.hidden) setMenuState(false);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const updateProductMedia = (section, variant) => {
    const mediaItems = [...section.querySelectorAll('.ceme-product__media')];
    if (!mediaItems.length) return;
    const variantId = String(variant.id);
    const hasVariantGroup = mediaItems.some((item) => item.dataset.variantMediaStart === variantId);
    let activeGroup = '';
    let firstVisibleImage = null;

    mediaItems.forEach((item) => {
      if (item.dataset.variantMediaStart) activeGroup = item.dataset.variantMediaStart;
      const visible = !hasVariantGroup || !activeGroup || activeGroup === variantId;
      item.hidden = !visible;
      item.classList.remove('is-variant-primary');
      if (visible && !firstVisibleImage) {
        item.classList.add('is-variant-primary');
        firstVisibleImage = item.querySelector('img');
      }
      if (!visible) {
        item.querySelectorAll('video').forEach((video) => video.pause());
      }
    });

    const quickImage = section.querySelector('[data-quick-bar-image] img');
    if (quickImage && firstVisibleImage) {
      quickImage.src = firstVisibleImage.currentSrc || firstVisibleImage.src;
      quickImage.srcset = firstVisibleImage.srcset;
      quickImage.alt = firstVisibleImage.alt || variant.name || '';
    }
  };

  const updateProductVariant = (section, variant) => {
    const variantInput = section.querySelector('[data-variant-id]');
    if (variantInput) variantInput.value = variant.id;
    const price = new Intl.NumberFormat(document.documentElement.lang || 'es-MX', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'MXN'
    }).format(variant.price / 100);
    section.querySelector('[data-product-price]').textContent = price;
    const availability = section.querySelector('[data-product-availability]');
    availability.classList.toggle('is-available', variant.available);
    availability.lastChild.textContent = variant.available ? 'Disponible' : 'Agotado';
    const button = section.querySelector('[data-add-to-cart]');
    button.disabled = !variant.available;
    button.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
    const quickVariant = section.querySelector('[data-quick-variant]');
    if (quickVariant) quickVariant.value = variant.id;
    const quickPrice = section.querySelector('[data-quick-bar-price]');
    if (quickPrice) quickPrice.textContent = price;
    const contactVariant = section.querySelector('[data-contact-variant]');
    if (contactVariant) contactVariant.value = variant.title || variant.name;
    const contactSku = section.querySelector('[data-contact-sku]');
    if (contactSku) contactSku.value = variant.sku || '';
    variant.options.forEach((value, index) => {
      const label = section.querySelector(`[data-option-label="${index + 1}"]`);
      if (label) label.textContent = value;
      const radio = [...section.querySelectorAll(`[data-option-position="${index + 1}"]`)]
        .find((input) => input.value === value);
      if (radio) radio.checked = true;
    });
    updateProductMedia(section, variant);
    window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
  };

  document.querySelectorAll('.ceme-product').forEach((section) => {
    const variants = JSON.parse(section.querySelector('[data-product-json]').textContent);
    const selectedId = Number(section.querySelector('[data-variant-id]')?.value);
    const selectedVariant = variants.find((variant) => variant.id === selectedId);
    if (selectedVariant) updateProductMedia(section, selectedVariant);
  });

  document.addEventListener('change', (event) => {
    const option = event.target.closest('[data-option-position]');
    if (!option) return;
    const section = option.closest('.ceme-product');
    if (!section) return;
    const variants = JSON.parse(section.querySelector('[data-product-json]').textContent);
    const selected = [...section.querySelectorAll('[data-option-position]:checked')].map((input) => input.value);
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    if (!variant) return;
    updateProductVariant(section, variant);
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const input = button.closest('.ceme-product__quantity').querySelector('input');
    const change = button.hasAttribute('data-quantity-plus') ? 1 : -1;
    input.value = Math.max(1, Number(input.value || 1) + change);
  });
  document.addEventListener('change', (event) => {
    const select = event.target.closest('select[data-quick-variant]');
    if (!select) return;
    const section = select.closest('.ceme-product');
    const variants = JSON.parse(section.querySelector('[data-product-json]').textContent);
    const variant = variants.find((item) => item.id === Number(select.value));
    if (variant) updateProductVariant(section, variant);
  });
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-quick-bar-close]');
    if (close) close.closest('[data-quick-bar]').hidden = true;
    const openContact = event.target.closest('[data-contact-open]');
    if (openContact) {
      const dialog = openContact.closest('.ceme-product').querySelector('[data-contact-dialog]');
      if (dialog?.showModal) dialog.showModal();
    }
    const closeContact = event.target.closest('[data-contact-close]');
    if (closeContact) closeContact.closest('[data-contact-dialog]').close();
  });
  document.addEventListener('click', (event) => {
    if (event.target.matches('[data-contact-dialog]')) event.target.close();
  });

  document.querySelectorAll('.ceme-product').forEach((section) => {
    if (section.dataset.productLightboxReady === 'true') return;
    section.dataset.productLightboxReady = 'true';

    const dialog = section.querySelector('[data-product-lightbox]');
    const viewport = section.querySelector('[data-product-zoom-viewport]');
    const image = section.querySelector('[data-product-zoom-image]');
    const resetButton = section.querySelector('[data-product-zoom-reset]');
    if (!dialog || !viewport || !image || !resetButton) return;

    let scale = 1;
    let baseWidth = 0;
    let opener = null;

    const renderScale = () => {
      const naturalLimit = image.naturalWidth || 2400;
      if (!baseWidth) baseWidth = Math.min(image.clientWidth || viewport.clientWidth, naturalLimit);
      image.style.width = `${Math.min(baseWidth * scale, naturalLimit)}px`;
      image.style.maxWidth = scale === 1 ? '100%' : 'none';
      image.style.maxHeight = scale === 1 ? 'calc(100vh - 108px)' : 'none';
      viewport.classList.toggle('is-zoomed', scale > 1);
      resetButton.textContent = `${Math.round(scale * 100)}%`;
    };

    const setScale = (nextScale) => {
      scale = Math.min(4, Math.max(1, Math.round(nextScale * 4) / 4));
      renderScale();
    };

    const resetZoom = () => {
      scale = 1;
      baseWidth = 0;
      image.style.width = '';
      image.style.maxWidth = '';
      image.style.maxHeight = '';
      viewport.classList.remove('is-zoomed');
      viewport.scrollTo(0, 0);
      resetButton.textContent = '100%';
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    section.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-product-zoom-open]');
      if (openButton) {
        opener = openButton;
        resetZoom();
        image.src = openButton.dataset.zoomSrc;
        image.alt = openButton.dataset.zoomAlt || '';
        dialog.showModal();
        image.addEventListener('load', renderScale, { once: true });
        return;
      }
      if (event.target.closest('[data-product-zoom-in]')) setScale(scale + .5);
      if (event.target.closest('[data-product-zoom-out]')) setScale(scale - .5);
      if (event.target.closest('[data-product-zoom-reset]')) resetZoom();
      if (event.target.closest('[data-product-zoom-close]')) closeDialog();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', () => {
      resetZoom();
      image.removeAttribute('src');
      opener?.focus();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === '+' || event.key === '=') {
        event.preventDefault();
        setScale(scale + .5);
      } else if (event.key === '-') {
        event.preventDefault();
        setScale(scale - .5);
      } else if (event.key === '0') {
        event.preventDefault();
        resetZoom();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const loadRecommendations = (section) => {
    if (!section || section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';
    fetch(section.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const replacement = html.querySelector('[data-product-recommendations]');
        if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
      })
      .catch(() => {});
  };
  document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          loadRecommendations(section);
          observer.disconnect();
        }
      }, { rootMargin: '300px' });
      observer.observe(section);
    } else {
      loadRecommendations(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-contact-form"] && !Shopify.designMode) return;
  try {
    
  if (!window.cemeSimpleContactInitialized) {
    window.cemeSimpleContactInitialized = true;

    const prepareSimpleContact = (section) => {
      if (!section || section.dataset.simpleContactReady === 'true') return;

      const form = section.querySelector('form');
      const code = section.querySelector('[data-phone-code]');
      const local = section.querySelector('[data-phone-local]');
      const combined = section.querySelector('[data-phone-combined]');
      const error = section.querySelector('[data-phone-error]');
      if (!form || !code || !local || !combined || !error) return;

      section.dataset.simpleContactReady = 'true';

      const validatePhone = () => {
        const option = code.options[code.selectedIndex];
        const digits = local.value.replace(/\D/g, '');
        const minimum = Number(option.dataset.min || 6);
        const maximum = Number(option.dataset.max || 15);
        let message = '';

        if (!digits) {
          message = 'Ingresa tu número de teléfono.';
        } else if (digits.length < minimum || digits.length > maximum) {
          message = `El número para ${option.textContent.split('+')[0].trim()} debe tener entre ${minimum} y ${maximum} dígitos.`;
        } else if (/^0+$/.test(digits) || /^(\d)\1{6,}$/.test(digits)) {
          message = 'Ingresa un número de teléfono válido.';
        }

        local.setCustomValidity(message);
        error.textContent = message;
        combined.value = message ? '' : `${option.value}${digits}`;
        return !message;
      };

      local.addEventListener('input', validatePhone);
      local.addEventListener('blur', validatePhone);
      code.addEventListener('change', validatePhone);
      form.addEventListener('submit', (event) => {
        if (!validatePhone()) {
          event.preventDefault();
          local.reportValidity();
          local.focus();
        }
      });
    };

    const prepareAllSimpleContacts = (root = document) => {
      root.querySelectorAll('[data-simple-contact-section]').forEach(prepareSimpleContact);
    };

    prepareAllSimpleContacts();
    document.addEventListener('shopify:section:load', (event) => prepareAllSimpleContacts(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ceme-slideshow]').forEach((slideshow) => {
    const slides = Array.from(slideshow.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;
    let index = 0;
    const setSlide = (nextIndex) => {
      slides[index].classList.remove('is-active');
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    };
    slideshow.querySelector('[data-prev]').addEventListener('click', () => setSlide(index - 1));
    slideshow.querySelector('[data-next]').addEventListener('click', () => setSlide(index + 1));
  });

  } catch(e) { console.error(e); }
})();
})();
